import spriteRaw from "@/assets/icons/sr-icons.svg?raw";

/**
 * Monter én gang i app-roten. Legger inn `<symbol>`-definisjonene så
 * `<SrIcon name="..." />` kan referere dem via `<use href="#sr-...">`.
 */
export function SrIconSprite() {
  return <div aria-hidden dangerouslySetInnerHTML={{ __html: spriteRaw }} style={{ display: "none" }} />;
}
